export const salaryStatusMap = {
  1: '已结算',
  2: '已确认入账'
}

export const salaryDetailTypeMap = {
  1: '维保负责人收入',
  2: '维修负责人收入',
  3: '指派执行收入',
  4: '指派负责人支出',
  5: '维保工单扣款'
}

export function buildSalarySummaryItems(detail = {}) {
  return [
    { label: '维保收入', value: detail.maintenanceIncome, detailType: 1 },
    { label: '维修收入', value: detail.repairIncome, detailType: 2 },
    { label: '指派收入', value: detail.assignIncome, detailType: 3 },
    { label: '指派支出', value: detail.assignExpense, detailType: 4 },
    { label: '维保工单扣款', value: detail.maintenanceDeduction, detailType: 5 }
  ]
}

export function formatSalaryAmount(value) {
  const amount = Number(value || 0)
  if (Number.isNaN(amount)) {
    return '0.00'
  }
  return amount.toFixed(2)
}

export function getSalaryAmountClassName(detailType) {
  if (detailType === 4 || detailType === 5) {
    return 'is-negative'
  }
  return ''
}

export function getSalaryStatusClassName(status) {
  if (status === 2) {
    return 'is-confirmed'
  }
  if (status === 1) {
    return 'is-settled'
  }
  return ''
}
